export default __webpack_public_path__ + "logo6e6cc10.png";